/* eslint-disable perfectionist/sort-enums */
import { enumToMap, mapToOptions } from "@utils";
import { z } from "zod";

import { SearchFormValuesProps } from "./types";

export enum TIMESPAN_ENUM {
  "common.date_unit_day" = "1",
  "common.date_unit_month" = "30",
  "common.date_unit_year" = "365",
}
export const TIMESPAN_MAP = enumToMap(TIMESPAN_ENUM);
export const TIMESPAN_OPTIONS = mapToOptions(TIMESPAN_MAP);

export enum VIEWSPAN_ENUM {
  "asset_dashboard.opt_fifty_years" = `${365 * 50}`,
  "asset_dashboard.opt_five_years" = `${365 * 5}`,
  "asset_dashboard.opt_one_month" = `${30}`,
  "asset_dashboard.opt_one_year" = `${365}`,
  "asset_dashboard.opt_six_months" = `${30 * 6}`,
  "asset_dashboard.opt_ten_years" = `${365 * 10}`,
  "asset_dashboard.opt_thirty_years" = `${365 * 30}`,
  "asset_dashboard.opt_three_months" = `${30 * 3}`,
  "asset_dashboard.opt_three_years" = `${365 * 3}`,
}
export const VIEWSPAN_MAP = enumToMap(VIEWSPAN_ENUM);
export const VIEWSPAN_OPTIONS = mapToOptions(VIEWSPAN_MAP);

// 定义数据验证模式
export const schema = z.object({
  inflation: z
    .number()
    .refine((v) => !isNaN(Number(v)) && Number(v) <= 100 && Number(v) >= 0, {
      message: "Inflation must be a number between 0 and 100",
    }),
  money: z.number().refine((v) => !isNaN(v)),
  profit: z
    .number()
    .refine((v) => !isNaN(Number(v)) && Number(v) <= 100 && Number(v) >= 0, {
      message: "Profit must be a number between 0 and 100",
    }),
});

export const defaultValues: SearchFormValuesProps = {
  inflation: 0,
  money: 1000000,
  prepayment: 0,
  profit: 3,
  timespanValue: TIMESPAN_ENUM["common.date_unit_day"],
  viewspanValue: VIEWSPAN_ENUM["asset_dashboard.opt_ten_years"],
};
